import { render, staticRenderFns } from "./UsersGrid.vue?vue&type=template&id=f5e6dd88"
import script from "./UsersGrid.vue?vue&type=script&lang=js"
export * from "./UsersGrid.vue?vue&type=script&lang=js"
import style0 from "./UsersGrid.vue?vue&type=style&index=0&id=f5e6dd88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports